// @ts-nocheck

import React from 'react';

type ErrorBoundaryProps = {
  onError: (error: Error, componentStack: string) => void;
  FallbackComponent: React.ComponentType<unknown>;
  children: React.ReactNode;
};

type ErrorBoundaryState = {
  value: number;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state = {
    error: null,
    info: null,
  };

  componentDidCatch(error, info) {
    const { onError } = this.props;

    if (typeof onError === 'function') {
      try {
        onError.call(this, error, info ? info.componentStack : '');
      } catch (ignoredError) {
        // do nothing
      }
    }

    this.setState({ error, info });
  }

  onRetry = () => {
    this.setState({ error: null, info: null });
  };

  render() {
    const { children, FallbackComponent, ...rest } = this.props;
    const { error } = this.state;

    if (error !== null) {
      return <FallbackComponent error={error} onRetry={this.onRetry} {...rest} />;
    }

    return children || null;
  }
}

export default ErrorBoundary;
